export function formatJoinMessage(message = {}) {
  const { msg_content = {} } = message
  const { love_invite_member = {}, love_room = {}, come_from, live_id, mode,
    receiver_member, sender_member,
  } = msg_content
  return {
    comeFrom: come_from,
    liveId: live_id,
    mode,
    targetMember: love_invite_member,
    roomInfo: love_room,
    receiverMember: receiver_member,
    senderMember: sender_member,
  }
}
